import { render, staticRenderFns } from "./RangeSliderSortingStatement.vue?vue&type=template&id=0e4cf40b&"
import script from "./RangeSliderSortingStatement.vue?vue&type=script&lang=ts&"
export * from "./RangeSliderSortingStatement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports